import React from 'react';
import { Grid, Card, CardContent, makeStyles, useTheme } from '@material-ui/core';
import ChatBubbleIcon from '@material-ui/icons/ChatBubble';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import WatchLaterIcon from '@material-ui/icons/WatchLater';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import { dateFormat } from '../../helpers';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  icon: {
    fontSize: 34,
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    margin: theme.spacing(7, 3), 
    padding: 0,

    '&:last-child': {
      padding: 0,
    }
  },
  containerInfo: {
    display: 'flex',
    justifyContent: 'center',
  },
  containerInfoDeep: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    fontSize: 28,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  titleClosed: {
    color: theme.palette.neutrals.low.medium,
    fontSize: 28,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  description: {
    color: theme.palette.neutrals.low.medium,
    fontSize: 12,
  },
  name: {
    fontSize: 20,
    fontWeight: 'bold',
    color: theme.palette.neutrals.low.main,  
  },
}));

function ChallengeFollowUp({ dueDate, daysLeft, ups, ideas, comments, user, area }) {
  const classes = useStyles();
  const theme = useTheme();

  const { t } = useTranslation();
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} lg={4}>
        <Card>
          {daysLeft >= 1 ? (
            <CardContent className={classes.content}>
              <div>
                <WatchLaterIcon
                  className={classes.icon}
                  style={{ color: theme.palette.primary.main }}
                />
              </div>
              <div className={classes.title} style={{ color: theme.palette.primary.main }}>
                {daysLeft} dia{daysLeft > 1 && 's'}
              </div>
              <div className={classes.description}>
                restantes para o fim do desafio
              </div>
            </CardContent>
          ) : (
            <CardContent className={classes.content}>
              <div>
                <WatchLaterIcon
                  className={classes.icon}
                  style={{ color: theme.palette.neutrals.low.medium }}
                />
              </div>
              <div className={classes.titleClosed}>
                {t('fase_encerrada')}
              </div>
              <div className={classes.description}>
                no dia {dateFormat(dueDate)}
              </div>
            </CardContent>
          )}
        </Card>
      </Grid>
      <Grid item xs={12} lg={8}>
        <Card>
          <CardContent className={classes.content}>
            <Grid container>
              <Grid item xs={4} lg={2} className={classes.containerInfo}>
                <div className={classes.containerInfoDeep}>
                  <div style={{ color: theme.palette.auxiliary.pink.main }}>
                    <AccountBoxIcon className={classes.icon} />
                    <div className={classes.title}>
                      {ideas || 0}
                    </div>
                  </div>
                  <div className={classes.description}>{t('ideias').toLowerCase()}</div>
                </div>
              </Grid>
              <Grid item xs={4} lg={2} className={classes.containerInfo}>
                <div className={classes.containerInfoDeep}>
                  <div style={{ color: theme.palette.auxiliary.blue.main }}>
                    <ThumbUpIcon className={classes.icon} />
                    <div className={classes.title}>
                      {ups || 0}
                    </div>
                  </div>
                  <div className={classes.description}>UP's</div>
                </div>
              </Grid>
              <Grid item xs={4} lg={2} className={classes.containerInfo}>
                <div className={classes.containerInfoDeep}>
                  <div style={{ color: theme.palette.auxiliary.orange.main }}>
                    <ChatBubbleIcon className={classes.icon} />
                    <div className={classes.title} >
                      {comments || 0}
                    </div>
                  </div>
                  <div className={classes.description}>{t('comentarios')}</div>
                </div>
              </Grid>
              <Grid item xs={12} lg={6} className={classes.containerInfo}>
                <div>
                  <div>
                    <div className={classes.description}>
                      {t('area_que_mais_contribuiu')}
                    </div>
                    <div className={classes.name}> 
                      {area} 
                    </div>
                  </div>
                  <div>
                    <div className={classes.description}>
                      colaborador que mais contribuiu
                    </div>
                    <div className={classes.name}> 
                      {user} 
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}

export { ChallengeFollowUp };
